/*
 *  Format date to yyyy-mm
 *  e.g. 2019-08
 *
 * */

import Vue from 'vue';

const formatDate = ( date ) => {
  let dateLocal = new Date(date);
  return `${dateLocal.getFullYear()}-${('0' + (dateLocal.getMonth() + 1)).slice(-2)}`;
};

Vue.filter('formatDate', formatDate);

export default formatDate;
